import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReferralFormQuestionGroupComponent } from './referral-form-question-group/referral-form-question-group.component';
import { QuestionGroupQuestionComponent } from './question-group-question/question-group-question.component';
import { OptionValueQuestionGroupComponent } from './option-value-question-group/option-value-question-group.component';
import { QuestionOptionComponent } from './question-option/question-option.component';

@NgModule({
  declarations: [
    ReferralFormQuestionGroupComponent, QuestionGroupQuestionComponent, OptionValueQuestionGroupComponent, QuestionOptionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatIconModule,
    MatRadioModule,
    MatCheckboxModule,
    NgSelectModule,
  ],
  exports: [
    ReferralFormQuestionGroupComponent, QuestionGroupQuestionComponent, OptionValueQuestionGroupComponent, QuestionOptionComponent
  ]
})
export class QuestionModule { }
